import React from 'react'
import Layout from '../../components/Layout'
import Intro from './Intro'
import ClientsList from './ClientsList'
import ClientsNum from './ClientsNum'
import ClientsReview from './ClientsReview'
import Footer from '../../components/Footer'

export const Testimonials = () => {
  return (
   <Layout classname="">
      <Intro />
      <ClientsList />
      <ClientsNum />
      <ClientsReview />
      <Footer/>
    </Layout>
  )
}
export default Testimonials